export default __webpack_public_path__ + "static/media/NaturalFill.c00a724d.png";